export const LANGUAGE_LOCKED = true;

export const LOCKED_LANGUAGE = 'GB';
